module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quote")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote),
      expression: "quote"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.quote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceQuoteAuthor"
    }
  }, [_vm._v("Author")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.author),
      expression: "author"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceQuoteAuthor"
    },
    domProps: {
      "value": (_vm.author)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.author = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceQuoteStar"
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "sliceQuoteStar",
      "options": ['0', '1', '2', '3', '4']
    },
    model: {
      value: (_vm.star),
      callback: function($$v) {
        _vm.star = $$v
      },
      expression: "star"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.visible),
      expression: "currentSlice.visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceQuoteVisible"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.visible) ? _vm._i(_vm.currentSlice.visible, null) > -1 : (_vm.currentSlice.visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.visible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceQuoteVisible"
    }
  }, [_vm._v("Visible")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.locked),
      expression: "currentSlice.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceQuoteLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.locked) ? _vm._i(_vm.currentSlice.locked, null) > -1 : (_vm.currentSlice.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceQuoteLocked"
    }
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSlice
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea0bd600"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/page-edit/modal/ModalQuote.vue
// module id = 271
// module chunks = 1